import styled from "styled-components";

export const PDPADuplicateFormStyled = styled.div`
  border-radius: 12px;
  padding: 20px;
  min-width: 500px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .form_title {
    margin-bottom: 20px;
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.BLACK_2};
  }
  .input_wrap {
    margin-bottom: 20px;
  }
  .action_row {
    display: flex;
    justify-content: flex-end;
    column-gap: 1rem;
    .btn_wrap {
      min-width: 120px;
    }
  }
`;
